module.exports = __webpack_public_path__ + "static/media/watch.79988f83.svg";